export default __webpack_public_path__ + "static/media/Kaploths.728a994a.jpg";